module.exports = __webpack_public_path__ + "static/img/open.ffcd59fa.png";